import { FaMapMarkerAlt, FaEye, FaUserCircle } from "react-icons/fa";
import { Row, Col, Button } from "reactstrap";
import playerImage from "../../../../src/assets/images/playerExemple.jpeg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { API_URL } from "constants/ApiUrl";

const PlayerInfo = ({ player }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    firstName,
    lastName,
    position,
    dateOfBirth,
    photo,
    status,
    nationality,
    experienceLevel,
    performance,
    // age
  } = player;

  const {
    goalsScored = 0,
    assists = 0,
    minutesPlayed = 0,
    cardsReceived = { yellow: 0, red: 0 },
  } = performance?.statistics || {};

  const age = new Date().getFullYear() - new Date(dateOfBirth).getFullYear();
  const [playerPhoto, setPlayerPhoto] = useState(null);
  useEffect(() => {
    if (player?.photo) {
      const cleanApiUrl = API_URL.replace(/\/+$/, '');

      let cleanLogo = player?.photo.replace(/\\/g, '/').replace(/^\/+/, '');

      if (!cleanLogo.startsWith('uploads/')) {
        cleanLogo = 'uploads/' + cleanLogo;
      }
      setPlayerPhoto(`${cleanApiUrl}/${cleanLogo}`);
    }
  }, [player])
  return (
    <div
      style={{
        marginTop: 15,
        padding: "20px",
        backgroundColor: "#f8f9fa",
        borderRadius: "10px",
      }}
    >
      <Row>
        {/* Première Colonne */}
        <Col
          md={4}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            {
              playerPhoto ?
                <img
                  src={playerPhoto}
                  alt="photo Joueur"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    marginRight: "15px",
                  }}
                />
                :
                <FaUserCircle size={72} className="text-secondary" style={{ marginRight: "15px" }} />
            }
            <h5 style={{ margin: 0, font: "Poppins", color: "#000000" }}>
              {firstName + " " + lastName}
            </h5>
          </div>
          <div style={{ marginBottom: "auto", marginTop: "auto" }}>
            <div>
              <span style={{ color: "#000000" }}>Position :</span>{" "}
              {player.position}
            </div>
            <div>
              <span style={{ color: "#000000" }}>Âge : </span>
              {age}
            </div>
          </div>
        </Col>

        {/* Deuxième Colonne */}
        <Col md={4}>
          <div style={{ marginBottom: "20px", marginTop: 15 }}>
            <h6
              style={{
                marginBottom: "10px",
                fontWeight: "bold",
                color: "#000000",
              }}
            >
              {t("playerInfo.Performance.keyStats")}
            </h6>
          </div>
          <div>
            <div>
              <span
                style={{
                  color: "#000000",
                }}
              >
                {t("playerInfo.Performance.golasNumber")} :
              </span>{" "}
              {goalsScored}
            </div>
            <div>
              <span
                style={{
                  color: "#000000",
                }}
              >
                {t("playerInfo.Performance.assists")} :
              </span>{" "}
              {assists}
            </div>
            <div>
              <span
                style={{
                  color: "#000000",
                }}
              >
                {t("playerInfo.Performance.minutesPlayed")} :
              </span>{" "}
              {minutesPlayed} min
            </div>
            <div>
              <span style={{ color: "#000" }}>
                {t("playerInfo.Performance.cardsReceived")} :
              </span>{" "}
              jaune ({cardsReceived.yellow}) / rouge ({cardsReceived.red})
            </div>
          </div>
        </Col>

        {/* Troisième Colonne */}
        <Col
          md={4}
          style={{
            paddingLeft: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                marginRight: "10px",
                backgroundColor: "#f0f0f0", // Couleur de fond grise
                borderRadius: "10px", // Bord arrondi
                padding: "1px", // Espacement interne

                fontSize: "12px", // Taille du texte
              }}
            >
              {experienceLevel}
            </div>
            <div>
              <FaMapMarkerAlt
                style={{ marginRight: "2px", color: "#007bff" }}
              />
              {nationality}
            </div>
          </div>
          <div
            style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
          >
            {/* <Button
              color="primary"
              style={{ backgroundColor: "#157088", borderRadius: "5px" }}
            >
              {t("playerInfo.contact")}
            </Button> */}
            <Button
              style={{
                color: "#157080",
                borderColor: "#157080",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                borderRadius: "8px",
              }}
              outline
              onClick={() => {
                navigate(`/joueurs/playerInfo/${player._id}`);
              }}
            >
              {t("playerInfo.seeProfile")}
              <FaEye style={{ color: "#157080" }} /> {/* Icône eye */}
            </Button>{" "}
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default PlayerInfo;
